// extracted by mini-css-extract-plugin
export var container = "_k5-0";
export var segment = "_k5-2";
export var segmentActive = "_k5-3";
export var track = "_k5-1";